import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid2 as Grid,
  Typography,
} from "@mui/material";
import { handleEmailVerificationReq } from "../../redux/user-slices/auth.slice";
import SkeletonImage from "../../components/ui/SkeletonImage";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Images from "../../assets/js/Images";

function Verification() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { other } = useSelector((state) => state.memberSlice);

  const handleVerification = () => {
    dispatch(handleEmailVerificationReq({ token }));
  };

  return (
    <Box sx={{ py: 3 }}>
      <Container maxWidth={false} fixed>
        <Grid container>
          <Grid size={{ xs: 12, md: 10, xl: 6 }} mx="auto">
            <Box
              sx={{
                gap: 2,
                display: "flex",
                textAlign: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "400px",
                }}
              >
                <SkeletonImage
                  sx={{ objectFit: "contain" }}
                  src={Images?.mainLogo}
                />
                <Divider sx={{ mt: 2 }} />
              </Box>
              <Typography
                sx={{
                  fontSize: "32px",
                  fontWeight: "600",
                  color: "other.color1",
                }}
                component="h2"
              >
                Verify Your Account
              </Typography>
              <Typography fontSize={20}>
                You're almost there! Click the button below to complete your
                account verification.
              </Typography>
              <Button
                sx={{
                  minWidth: "150px",
                  justifyContent: "center",
                }}
                color="primary"
                variant="contained"
                onClick={handleVerification}
                endIcon={
                  other?.loadingLogin && (
                    <CircularProgress size={20} thickness={6} />
                  )
                }
              >
                Verify now
              </Button>
              <Typography variant="body2">
                If you didn't request this, please ignore this message.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Verification;
